export default __webpack_public_path__ + "static/agency_seoulTech-2decaa9eca0337bb7323fad42e6fcee6.jpg";